import {Component} from '@angular/core';

@Component({
  selector: 'spt-policies-page',
  templateUrl: './page-policies.component.html',
  styleUrls: ['./page-policies.component.scss']
})
export class PagePoliciesComponent {}
